import {createI18nScope} from 'common/i18n/scope';

export default createI18nScope(`common.query-builder.query-entry-section.row-types.behavior`, {
  'query-builder.add-item': `Add {{item}}`,
  'query-builder.attribution.lookback-duration': `{{duration}} Lookback`,
  'query-builder.behavior-interval.after-step-1': `After Step 1`,
  'query-builder.behavior-interval.between-funnel-steps': `Between Funnel Steps`,
  'query-builder.behavior-interval.between-steps': `Between Steps`,
  'query-builder.behavior-interval.per-interval': `Per Interval`,
  'query-builder.behavior.on': `on`,
  'query-builder.count-menu.agg-prop-per-dg': `Aggregate Property per {{dataGroupName}}`,
  'query-builder.count-menu.frequency-per-dg': `Frequency per {{dataGroupName}}`,
  'query-builder.count-menu.number-of-users-who-did': `Number of Users who did...`,
  'query-builder.dg-user': `User`,
  'query-builder.dg-user_other': `Users`,
  'query-builder.items.attributed-by.prefix': `Attributed by `,
  'query-builder.property-agg.menu-label': `Aggregate by`,
});
